






import { Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {UserModule} from '@/store/modules/user'
import {AppModule} from '@/store/modules/app'
@Component({
  components: {
  }
})
export default class extends Vue {
  private get isShow () {
    let {hiddenBackBtn}  = this.$route.meta
    if (AppModule.containerType === 'cep') {
      return false
    }
    return UserModule.user.id && !hiddenBackBtn
  }
  private back () {
    let {backLength = -1, backRoute} = this.$route.meta
    if (backRoute) {
      this.$router.push(backRoute)
      return
    }
    if (backLength === -1) {
      this.$router.go(-1)
      return
    }
    let path = this.$route.path
    let arr = path.split('/').slice(0, -backLength)
    this.$router.push(arr.join('/'))
  }
  @Watch('$route.params')
	private routeUpdata (oldV: any, newV: any) {
    // 触发浏览器返回时，关闭预览窗口
		this.$messageInstance?.close();
    
	}
}
